import React from "react";
import Modal from "react-modal";

import { ReactComponent as CrossInWhiteCircle } from "../../../assets/icons/cross-in-white-circle.svg";
import { Button } from "../../forms/Button/Button";

import "./NotesDelete.styles.scss";

interface IDeleteConfirmModal {
  isOpen: number;
  onConfirm: (deleteId: number) => Promise<void>;
  onRequestClose: () => void;
  loading: boolean;
}

export const DeleteConfirmModal: React.FC<IDeleteConfirmModal> = ({
  isOpen,
  onConfirm,
  onRequestClose,
  loading
}): JSX.Element => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: 0,
      border: "none",
      overflow: "none",
      borderTopLeftRadius: "10px",
      borderTopRightRadius: "10px"
    }
  };

  return (
    <Modal isOpen={!!isOpen} style={customStyles} onRequestClose={onRequestClose} shouldCloseOnEsc>
      <div className="notes-delete-modal">
        <div className="notes-delete__header flex-col-fc-fc">
          <CrossInWhiteCircle className="notes-delete__icon" />
          <span className="notes-delete__title flex-row-fc-fc">ARE YOU SURE?</span>
        </div>
        <div className="notes-delete__main">
          <span className="notes-delete__reference flex-row-fs-fs">
            Do you really want to delete these note? This process cannot be undone
          </span>
          <div className="flex-row-sb-fc">
            <Button
              onClick={onRequestClose}
              className="notes-delete__cancel"
              variant="oval-border"
              title="Cancel"
              isLoading={loading}
            />
            <Button
              onClick={async () => {
                await onConfirm(isOpen);
                onRequestClose();
              }}
              className="notes-delete__confirm"
              title="Delete"
              isLoading={loading}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
